import { ArcadeMachineSearchPage } from '@/src/components/pages/ArcadeMachineSearchPage'
import { useRouter } from 'next/router'

const Page = () => {
  const gameId = (useRouter().query.gameId as string) ?? ''
  return <ArcadeMachineSearchPage gameId={gameId} />
}

export default Page
